import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { openItemsCount } from "../lib/actionItemOverlays";

/** Open action-item count — mock data with localStorage overlay status applied. */
export function useOpenItemsCount(): number {
  const location = useLocation();
  return useMemo(() => openItemsCount(), [location.pathname]);
}
